export enum NodeClasses {
  AREA,
  DEVICE,
  TAG,
  CROP,
  EXTENSION,
  PANEL
}
